// extracted by mini-css-extract-plugin
export default {"RegisterSuccess":"RegisterSuccess_RegisterSuccess__5v+eV"};